import { useEffect, useRef, useState } from "react";
import LabelInput from "../../../Component/labelInput";
import PageTitle from "../../../module/pageTitle";
import { Submitbtn } from "../../../Component";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../store";
import { getCategoryList, getProductTypeList } from "../adminSlice";
import DateTimePicker from "../../../Component/dateTimePicker";
import moment from "moment";
import DropdownWithClear from "../../../Component/dropdownWithClear";
import AdminTable from "../../../Component/adminTable";
import { DownloadTableExcel } from "react-export-table-to-excel";
import DatePicker from "../../../Component/datePicker";
import DispatchOrderPrint from "../../../Component/dispatchOrderPrint";
import DispatchOrderPopup from "../../../Component/dispatchOrderPopup";

const DispatchOrder = () => {
  const tableRef = useRef(null);
  const dispatch: Function = useDispatch<AppDispatch>();
  const [productTypeList, setProductTypeList] = useState<any>([]);
  const [productType, setProductType] = useState<any>("");
  const [category, setCategory] = useState<any>("");
  const [categoryList, setCategoryList] = useState<any>([]);
  const [startDate, setStartDate] = useState<any>(
    moment.utc(new Date()).format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState<any>(
    moment.utc(new Date()).format("YYYY-MM-DD")
  );
  const [dispatchOrderList, setDispatchOrderList] = useState<any>([]);
  const [Status, setStatus] = useState(0);
  const [show, setShow] = useState(false);
  const [orderPrintList, setOrderPrintList] = useState<any>([]);
  const [open, setOpen] = useState(false);
  const [openClose, setOpenClose] = useState(false);

  useEffect(() => {
    dispatch(
      getProductTypeList({
        callback: (res: any) => {
          setProductTypeList(res?.data);
        },
        errorCallback: () => {},
      })
    );
    setDispatchOrderList(dispatchList);
  }, []);

  const dispatchList = [
    {
      sn: 1,
      orderNo: "123",
      orderDate: "2021-09-12",
      buyerName: "Ram",
      state: "Karnataka",
      mobileNumber: "1234567890",
      amount: "1000",
      dispatchDate: "2021-09-12",
      action: "Dispatch",
      _id: 1,
    },
  ];

  const onchangeProductType = (value: any) => {
    setProductType(value);
    const postData = {
      productTypeId: value?._id,
    };
    dispatch(
      getCategoryList({
        params: postData,
        callback: (res: any) => {
          setCategoryList(res);
        },
        errorCallback: (error: any) => {},
      })
    );
  };
  const onchangeCategory = (value: any) => {
    setCategory(value);
  };

  const getData = (val: any) => {
    setStatus(val);
  };
  const printValidations = () => {
    let result = true;
    let indexes = dispatchOrderList?.filter((elm: any) => elm.isSelected);
    if (indexes?.length > 0) {
      result = false;
    }
    return result;
  };

  const handlePrint = (e: any) => {
    let newArray = JSON.parse(JSON.stringify(dispatchOrderList));
    let indexes = newArray
      .map((elm: any, idx: any) => (!elm.isSelected ? idx : ""))
      .filter(String);
    for (var i = indexes?.length - 1; i >= 0; i--) {
      newArray.splice(indexes[i], 1);
    }
    let newArrr3: any = [];
    newArray.map((item: any) => {
      newArrr3.push(item._id);
      return null;
    });

    // dispatch(
    //   getPrintSMOrderList(
    //     {
    //       orderIds: newArrr3,
    //     },
    //     (res) => {
    //       setSMPrintList(res?.data);
    //     },
    //     () => {}
    //   )
    // );
    e.preventDefault();
    setShow(true);
  };

  const onchangeStartDate = (value: any) => {
    setStartDate(value);
  };
  const onchangeEndDate = (value: any) => {
    setEndDate(value);
  };
  const handlePrintClose = () => {
    setShow(false);
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
  };
  const validations = () => {
    let valid = false;
    if (startDate === "" || endDate === "") {
      valid = true;
    }
    return valid;
  };

  const handleCheck = (data: any, index: any) => {
    let newArray = JSON.parse(JSON.stringify(dispatchOrderList));
    if (data.target.checked) {
      newArray[index]["isSelected"] = true;
      setDispatchOrderList(newArray);
    } else {
      newArray[index]["isSelected"] = false;
      setDispatchOrderList(newArray);
    }
  };
  const handleClose = (value: any) => {
    setOpenClose(false);
  };
  const handleEdit = (value: any) => {
    setOpenClose(true);
  };
  const renderTable = () => {
    return (
      <div className="mt-4">
        <AdminTable
          tableData={dispatchList ? dispatchList : []}
          pagename={"dispatchorder"}
          tableHead={[
            "",
            "S.N",
            "ORDER NO",
            "ORDER DATE",
            "BUYER NAME",
            "STATE",
            "MOBILE NUMBER",
            "AMOUNT",
            "DISPATCH DATE",
            "ACTION",
          ]}
          handleCheck={(value: any, index: any) => handleCheck(value, index)}
          handleEdit={(value: any) => handleEdit(value)}
        />
      </div>
    );
  };
  return (
    <div className="panel-content">
      <div className="mb-4">
        <PageTitle name={"DISPATCH ORDER"} />
      </div>
      <div className="formDiv bxshadow">
        <div className=" p-2 borderRadius mb-4 ">
          <form onSubmit={handleSubmit}>
            <div className="row ">
              <div className="col-md-4 mb-3">
                <LabelInput labelName={"Start Date"} isRequired />
                <DatePicker
                  setInputText={(value: any) => {
                    onchangeStartDate(value);
                  }}
                  value={startDate}
                />
              </div>
              <div className="col-md-4 mb-3">
                <LabelInput labelName={"End Date"} isRequired />
                <DatePicker
                  setInputText={(value: any) => {
                    onchangeEndDate(value);
                  }}
                  value={endDate}
                />
              </div>
              <div className="col-md-4 mb-3">
                <LabelInput labelName={"Product Type"} />
                <DropdownWithClear
                  labelName={"Select Product Type"}
                  setInputText={(value: any) => onchangeProductType(value)}
                  options={productTypeList}
                  value={productType}
                />
              </div>
              <div className="col-md-4 mb-3">
                <LabelInput labelName={"Category"} />
                <DropdownWithClear
                  labelName={"Select Product category "}
                  setInputText={(value: any) => onchangeCategory(value)}
                  options={categoryList}
                  value={category}
                />
              </div>
              <div className="col-md-4 mt-3">
                <div className="col-2 pt-2">
                  <Submitbtn name={"Search"} disabled={validations()} />
                </div>
              </div>
              <div
                className="d-flex justify-content-between p-2 mt-4"
                style={{ backgroundColor: "#E8EAF5" }}
              >
                <div>
                  <button
                    type="button"
                    className={`btn rounded-pill me-1 font-12 ${
                      Status === 0 ? "btn-success" : "btn-secondary"
                    }`}
                    onClick={() => getData(0)}
                  >
                    Pending
                  </button>
                  <button
                    type="button"
                    className={`btn rounded-pill me-1 font-12 ${
                      Status === 1 ? "btn-success" : "btn-secondary"
                    }`}
                    onClick={() => getData(1)}
                  >
                    Partial Dispatched
                  </button>
                  <button
                    type="button"
                    className={`btn rounded-pill me-1 font-12 ${
                      Status === 2 ? "btn-success" : "btn-secondary"
                    }`}
                    onClick={() => getData(2)}
                  >
                    Dispatched
                  </button>
                  <button
                    type="button"
                    className={`btn rounded-pill me-1 font-12 ${
                      Status === 3 ? "btn-success" : "btn-secondary"
                    }`}
                    onClick={() => getData(3)}
                  >
                    Returned
                  </button>
                  <button
                    type="button"
                    className={`btn rounded-pill me-1 font-12 ${
                      Status === 4 ? "btn-success" : "btn-secondary"
                    }`}
                    onClick={() => getData(4)}
                  >
                    Delievered
                  </button>
                </div>
                <div>
                  {dispatchOrderList?.length > 0 ? (
                    <DownloadTableExcel
                      filename="users table"
                      sheet="users"
                      currentTableRef={tableRef.current}
                    >
                      <button
                        type="button"
                        className=" dispachprintBtn  py-2  rounded-pill font-12 me-1"
                      >
                        Export Details
                      </button>
                    </DownloadTableExcel>
                  ) : null}
                  {dispatchOrderList?.length > 0 ? (
                    <button
                      type="button"
                      className={` ${
                        printValidations()
                          ? "btn rounded-pill font-12  btn-secondary"
                          : "dispachprintBtn rounded-pill font-12"
                      }`}
                      disabled={printValidations()}
                      onClick={handlePrint}
                    >
                      Print Details
                    </button>
                  ) : null}
                </div>
              </div>

              <div ref={tableRef}>{renderTable()}</div>
            </div>
          </form>
        </div>
      </div>
      <DispatchOrderPrint
        open={show}
        handlePrintClose={handlePrintClose}
        data={orderPrintList.length > 0 ? orderPrintList : null}
      />
      <DispatchOrderPopup open={openClose} handleClose={handleClose} />
    </div>
  );
};

export default DispatchOrder;
